import { VariantProps } from 'class-variance-authority'
import React from 'react'
import { Link, LinkProps } from 'react-router-dom'

import { classes } from '../utils'
import { buttonVariants } from './Button'

type LinkOrAnchor = LinkProps | React.AnchorHTMLAttributes<HTMLAnchorElement>
type BaseProps = {
  isExternal?: boolean
  isBlank?: boolean
  disabled?: boolean
} & VariantProps<typeof buttonVariants>

type Props = BaseProps & LinkOrAnchor

export function LinkButton({
  isExternal,
  isBlank,
  variant,
  size,
  className,
  disabled,
  ...props
}: Props) {
  const blankProps = isBlank
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : { target: props.target, rel: props.rel }

  if ('to' in props && !isExternal) {
    return (
      <Link
        className={classes(
          buttonVariants({ variant, size }),
          { 'pointer-events-none': disabled },
          className,
        )}
        {...props}
        {...blankProps}
      />
    )
  }

  return (
    <a
      className={classes(
        buttonVariants({ variant, size }),
        { 'pointer-events-none': disabled },
        className,
      )}
      {...props}
      {...blankProps}
    />
  )
}
